<div class="homepage-container"
    *ngIf="show && ((isDesktop && (stepDesktop$ | async) === 'LANDING') || (!isDesktop && (step$ | async) === 'LANDING'))">
    <app-smash-external-html [externalContent]="discoverHtmlUrl"></app-smash-external-html>

    <div class="footer-placeholder">
        <footer>
            <p [innerHtml]="'HOMEPAGE_FOOTER_TITLE' | translate | safeHtml"
                class="footer-main-title"></p>
            <div class="footer-content">
                <div class="bloc footer-col">
                    <p [innerHtml]="'HOMEPAGE_FOOTER_COL_1_TITLE' | translate | safeHtml"
                        class="footer-subtitle"></p>
                    <ul class="footer-list">
                        <li><a href="{{ 'HOMEPAGE_FOOTER_COL_1_ITEM_1_LINK' | translate}}"
                                [innerHtml]="'HOMEPAGE_FOOTER_COL_1_ITEM_1' | translate | safeHtml"></a></li>
                        <li><a href="{{ 'HOMEPAGE_FOOTER_COL_1_ITEM_2_LINK' | translate}}"
                                [innerHtml]="'HOMEPAGE_FOOTER_COL_1_ITEM_2' | translate | safeHtml"></a></li>
                        <li><a href="{{ 'HOMEPAGE_FOOTER_COL_1_ITEM_3_LINK' | translate}}"
                                [innerHtml]="'HOMEPAGE_FOOTER_COL_1_ITEM_3' | translate | safeHtml"></a></li>
                        <li><a href="{{ 'HOMEPAGE_FOOTER_COL_1_ITEM_4_LINK' | translate}}"
                                [innerHtml]="'HOMEPAGE_FOOTER_COL_1_ITEM_4' | translate | safeHtml"></a></li>
                        <li><a href="{{ 'HOMEPAGE_FOOTER_COL_1_ITEM_5_LINK' | translate}}"
                                [innerHtml]="'HOMEPAGE_FOOTER_COL_1_ITEM_5' | translate | safeHtml"></a></li>
                        <li><a href="{{ 'HOMEPAGE_FOOTER_COL_1_ITEM_6_LINK' | translate}}"
                                [innerHtml]="'HOMEPAGE_FOOTER_COL_1_ITEM_6' | translate | safeHtml"></a></li>
                        <li><a target="_blank"
                                href="{{ 'HOMEPAGE_FOOTER_COL_1_ITEM_7_LINK' | translate}}"
                                [innerHtml]="'HOMEPAGE_FOOTER_COL_1_ITEM_7' | translate | safeHtml"></a></li>
                    </ul>
                </div>
                <div class="bloc footer-col">
                    <p [innerHtml]="'HOMEPAGE_FOOTER_COL_2_TITLE' | translate | safeHtml"
                        class="footer-subtitle"></p>
                    <ul class="footer-list">
                        <li><a href="{{ 'HOMEPAGE_FOOTER_COL_2_ITEM_1_LINK' | translate}}"
                                [innerHtml]="'HOMEPAGE_FOOTER_COL_2_ITEM_1' | translate | safeHtml"></a></li>
                        <li><a href="{{ 'HOMEPAGE_FOOTER_COL_2_ITEM_2_LINK' | translate}}"
                                [innerHtml]="'HOMEPAGE_FOOTER_COL_2_ITEM_2' | translate | safeHtml"></a></li>
                        <li><a href="{{ 'HOMEPAGE_FOOTER_COL_2_ITEM_3_LINK' | translate}}"
                                [innerHtml]="'HOMEPAGE_FOOTER_COL_2_ITEM_3' | translate | safeHtml"></a></li>
                        <li><a href="{{ 'HOMEPAGE_FOOTER_COL_2_ITEM_4_LINK' | translate}}"
                                [innerHtml]="'HOMEPAGE_FOOTER_COL_2_ITEM_4' | translate | safeHtml"></a></li>
                        <li><a href="{{ 'HOMEPAGE_FOOTER_COL_2_ITEM_5_LINK' | translate}}"
                                [innerHtml]="'HOMEPAGE_FOOTER_COL_2_ITEM_5' | translate | safeHtml"></a></li>
                        <li><a href="{{ 'HOMEPAGE_FOOTER_COL_2_ITEM_6_LINK' | translate}}"
                                [innerHtml]="'HOMEPAGE_FOOTER_COL_2_ITEM_6' | translate | safeHtml"></a></li>
                        <li><a href="{{ 'HOMEPAGE_FOOTER_COL_2_ITEM_7_LINK' | translate}}"
                                [innerHtml]="'HOMEPAGE_FOOTER_COL_2_ITEM_7' | translate | safeHtml"></a></li>
                        <li><a href="{{ 'HOMEPAGE_FOOTER_COL_2_ITEM_8_LINK' | translate}}"
                                [innerHtml]="'HOMEPAGE_FOOTER_COL_2_ITEM_8' | translate | safeHtml"></a></li>
                    </ul>
                </div>
                <div class="bloc footer-col">
                    <p [innerHtml]="'HOMEPAGE_FOOTER_COL_3_TITLE' | translate | safeHtml"
                        class="footer-subtitle"></p>
                    <ul class="footer-list">
                        <li><a href="{{ 'HOMEPAGE_FOOTER_COL_3_ITEM_1_LINK' | translate}}"
                                [innerHtml]="'HOMEPAGE_FOOTER_COL_3_ITEM_1' | translate | safeHtml"></a></li>
                        <li><a href="{{ 'HOMEPAGE_FOOTER_COL_3_ITEM_2_LINK' | translate}}"
                                [innerHtml]="'HOMEPAGE_FOOTER_COL_3_ITEM_2' | translate | safeHtml"></a></li>
                        <li><a href="{{ 'HOMEPAGE_FOOTER_COL_3_ITEM_3_LINK' | translate}}"
                                [innerHtml]="'HOMEPAGE_FOOTER_COL_3_ITEM_3' | translate | safeHtml"></a></li>
                        <li><a href="{{ 'HOMEPAGE_FOOTER_COL_3_ITEM_4_LINK' | translate}}"
                                [innerHtml]="'HOMEPAGE_FOOTER_COL_3_ITEM_4' | translate | safeHtml"></a></li>
                    </ul>
                </div>
                <div class="bloc footer-col">
                    <p [innerHtml]="'HOMEPAGE_FOOTER_COL_4_TITLE' | translate | safeHtml"
                        class="footer-subtitle"></p>
                    <ul class="footer-list">
                        <li><a target="_blank"
                                href="{{ 'HOMEPAGE_FOOTER_COL_4_ITEM_1_LINK' | translate}}"
                                [innerHtml]="'HOMEPAGE_FOOTER_COL_4_ITEM_1' | translate | safeHtml"></a></li>
                        <li><a href="{{ 'HOMEPAGE_FOOTER_COL_4_ITEM_2_LINK' | translate}}"
                                [innerHtml]="'HOMEPAGE_FOOTER_COL_4_ITEM_2' | translate | safeHtml"></a></li>
                        <li><a href="{{ 'HOMEPAGE_FOOTER_COL_4_ITEM_3_LINK' | translate}}"
                                [innerHtml]="'HOMEPAGE_FOOTER_COL_4_ITEM_3' | translate | safeHtml"></a></li>
                    </ul>
                </div>
                <div class="bloc footer-col">
                    <div class="store">
                        <a target="_blank"
                            href="{{ 'HOMEPAGE_FOOTER_APP_STORE_LINK' | translate }}"><img loading="lazy"
                                src="/assets/img/appstore.png"
                                alt=""></a>
                        <a target="_blank"
                            href="{{ 'HOMEPAGE_FOOTER_GOOGLE_STORE_LINK' | translate }}"><img loading="lazy"
                                src="/assets/img/google-play.png"
                                alt=""></a>
                    </div>
                    <hr>
                    <div>
                        <a target="_blank"
                            class="social"
                            href="{{ 'HOMEPAGE_FOOTER_LINKEDIN_LINK' | translate }}"><i class="icon-smash_linkedin2"></i></a>
                        <a target="_blank"
                            class="social"
                            href="{{ 'HOMEPAGE_FOOTER_FACEBOOK_LINK' | translate }}"><i class="icon-smash_facebook"></i></a>
                        <a target="_blank"
                            class="social"
                            href="{{ 'HOMEPAGE_FOOTER_TWITTER_LINK' | translate }}"><i class="icon-smash_twitter"></i></a>
                        <a target="_blank"
                            class="social"
                            href="{{ 'HOMEPAGE_FOOTER_INSTAGRAM_LINK' | translate }}"><i class="icon-smash_instagram"></i></a>
                        <a target="_blank"
                            class="social"
                            href="{{ 'HOMEPAGE_FOOTER_YOUTUBE_LINK' | translate }}"><i class="icon-smash_youtube"></i></a>
                    </div>
                </div>
            </div>
            <hr>
            <div class="footer-copyright-language">
                <p class="copyright">Smash & Co © 2017-{{yearnow}}</p>
                <div class="select-lang-container">
                    <app-smash-select-lang dropdownDirection="up"
                        chevronColor="#FFF"></app-smash-select-lang>
                </div>
            </div>
        </footer>
    </div>

</div>